/**
 * THE COMPETITION BEING WORKED ON — remembered across page loads (14 Oct 2026).
 *
 * Chosen on «Змагання»; a reload used to throw it away and leave the page
 * empty, and «Заявки» showed every competition's applications regardless.
 * Now /competitions comes back on the same competition, and /applications
 * opens filtered to it — when one is chosen; nothing chosen, nothing filtered.
 *
 * An id only: what it names is always looked up in the competitions the
 * server returned, so a competition this user may no longer see is simply
 * not restored. Logging out forgets it (removeUserToken), so the next person
 * on a shared venue laptop starts from nothing.
 */
const STORAGE_KEY = 'selectedCompetition';

export const getSelectedCompetition = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) || null;
    } catch (e) {
        // Private browsing, or a locked-down profile: the page still works,
        // it just forgets.
        return null;
    }
};

export const storeSelectedCompetition = competitionId => {
    try {
        if (competitionId) {
            window.localStorage.setItem(STORAGE_KEY, competitionId);
        } else {
            window.localStorage.removeItem(STORAGE_KEY);
        }
    } catch (e) {
        /* see getSelectedCompetition */
    }
};

/*
 * …and the CATEGORY open in it (14 Oct 2026: «обрану категорію теж
 * зберігай»). Kept WITH its competition: a category is restored only into the
 * competition it was chosen in, never carried over to another.
 */
const CATEGORY_STORAGE_KEY = 'selectedCategory';

export const getSelectedCategory = competitionId => {
    try {
        const stored = JSON.parse(window.localStorage.getItem(CATEGORY_STORAGE_KEY) || 'null');

        return stored && competitionId && stored.competition === competitionId && 'string' === typeof stored.category
            ? stored.category
            : null;
    } catch (e) {
        return null;
    }
};

export const storeSelectedCategory = (competitionId, categoryId) => {
    try {
        if (competitionId && categoryId) {
            window.localStorage.setItem(CATEGORY_STORAGE_KEY, JSON.stringify({ competition: competitionId, category: categoryId }));
        } else {
            window.localStorage.removeItem(CATEGORY_STORAGE_KEY);
        }
    } catch (e) {
        /* see getSelectedCompetition */
    }
};
